'use client';

import React from 'react';
import { Box, Stack } from '@mui/material';
import CommonContainer from '@components/CommonContainer';
import { CustomRegistration } from '@components/CustomRegistration';
import ParallaxBlock from '@components/ParallaxBlock';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import { Mobile } from '@components/Mobile';
import { Desktop } from '@components/Desktop';
import cn from './style.module.scss';
export const WESTMINSTER_TOWER_REGISTRATION_ID =
  'westminsterTowerRegistrationID';
export default function WestminsterTowerRegistration(props: any) {
  const { locale, links, leadConfig } = props;
  return (
    <Stack component="section" className={cn.westminsterTowerRegistration}>
      <Box className={cn.westminsterRegistrationInner}>
        <CommonContainer
          paddingInline={{ xs: '32px', sm: '32px', md: '24px' }}
          maxWidth={{ xs: '100%', md: '1200px', lg: '1400px' }}
          flexGrow={1}
        >
          <Box className={cn.westminsterRegistrationBlock}>
            <Box className={cn.westminsterRegistrationContent}>
              <Box className={cn.westminsterRegistrationContent__heading}>
                <Mobile>
                  <ParallaxText
                    variant="h2"
                    animationType="slideInBottom"
                    animationDuration={500}
                  >
                    {ReactHtmlParser(
                      props.locale.section
                        .westminsterTowerRegistrationHeadingMobile
                    )}
                  </ParallaxText>
                </Mobile>
                <Desktop>
                  <ParallaxText
                    variant="h2"
                    animationType="slideInBottom"
                    animationDuration={500}
                  >
                    {ReactHtmlParser(
                      props.locale.section
                        .westminsterTowerRegistrationHeadingDesktop
                    )}
                  </ParallaxText>
                </Desktop>
              </Box>
              <Box className={cn.westminsterRegistrationContent__data}>
                <ParallaxText
                  variant="p"
                  animationType="zoomIn"
                  animationDuration={500}
                >
                  {ReactHtmlParser(
                    props.locale.section.westminsterTowerRegistrationContent
                  )}
                </ParallaxText>
              </Box>
            </Box>
            <Box className={cn.westminsterRegistrationForms}>
              <CustomRegistration
                t={locale.section}
                scrollId={WESTMINSTER_TOWER_REGISTRATION_ID}
                successPopUpLink={links.successPopupRedirection}
                privacyPolicyLink={links.privacyPolicy}
                termsAndConditionsLink={links.termsAndConditions}
                formId={leadConfig.formId}
                formType={leadConfig.formType}
                projectName={leadConfig.projectName}
                variant="modal"
                className={cn.westminsterTowerRegisterOuter}
                listClassName={cn.westminsterTowerRegisterList}
                blockClassName={cn.westminsterTowerRegisterBlock}
                inputClassName={cn.westminsterTowerRegisterInput}
                elementClassName={cn.westminsterTowerRegisterElement}
                submitBlockClassName={cn.westminsterTowerRegisterSubmitBlock}
                submitClassName={cn.westminsterTowerRegisterButton}
                marksClassName={cn.westminsterTowerRegisterMarks}
                wrapperClassName={cn.westminsterTowerRegisterSuccessWrapper}
                contentClassName={cn.westminsterTowerRegisterSuccessContent}
                buttonClassName={cn.westminsterTowerRegisterSuccessButton}
              />
            </Box>
          </Box>
        </CommonContainer>
      </Box>
    </Stack>
  );
}
